import React from "react";
import { t } from "../../../helpers/translator";

export default function lockTerminalTemplate() {
	return (
		<div className="ticket-results-view-p">
			<h3>{t("Would you like to cashout")}?</h3>
			{!this.props.isAdminLoggedIn && <p>{t("Please ask administrator for confirmation")}</p>}
			<div className="buttons-view-w-t">
				<ul>
					<li>
						<div className="separator-box-buttons-m">
							<button
								className={
									this.props.isAdminLoggedIn
										? "button-view-normal-m"
										: "button-view-normal-m trans-m"
								}
								onClick={this.props.isAdminLoggedIn && this.cashOut()}
							>
								{t("Yes")}
							</button>
						</div>
					</li>
					<li>
						<div className="separator-box-buttons-m">
							<button
								className="button-view-normal-m trans-m"
								onClick={this.props.closePopup()}
							>
								{t("Cancel")}
							</button>
						</div>
					</li>
				</ul>
			</div>
		</div>
	);
}
